export default __webpack_public_path__ + "static/gen-logo-891530a195973fa26c31fbf55074f497.svg";